import Settings from "../../settings/Settings";
import { WazToolbar } from "../toolbar/WazToolbar";

import "./WazPersonalSettings.css";

export const WazPersonalSettings = () => {
    return (
       <div className="waz-personal-settings">
            <WazToolbar />
            <div className="waz-personal-settings-content">
                <Settings />
            </div>
       </div>
    );
};